var angular = require('angular');


module.exports = angular.module('app.directives', ['documents']);

require('./app-stats')
require('./app-stats-funder')
require('./applicationSummaryIcon')
require('./barometers')
require('./charitable-categories')
require('./contentField')
require('./contentUpload')
require('./cookie-consent')
require('./cropit')
require('./currency-input')
require('./datemask')
require('./datepicker')
require('./datetime')
require('./dualListBox')
require('./edit-btn')
require('./featured-projects')
require('./geomatch')
require('./global-search')
require('./httpPrefix')
require('./inline-edit-btn')
require('./inline-form')
require('./legal-status-options')
require('./lightbox')
require('./messaging')
require('./moment')
// require('./ngtweet')
require('./notes')
require('./notification-settings')
require('./notifications-count')
require('./nsPopover')
require('./number-input')
require('./organisationUsers')
require('./paginator')
require('./photo-upload')
require('./project-filters')
require('./public-banner')
require('./publicInformation')
require('./question-help-text-icon')
require('./questionSets')
require('./read-more')
require('./report-list')
require('./rr-focus-me')
require('./rr-inline-edit')
require('./rr-password-policy')
require('./show-errors')
require('./social-links')
require('./social-share')
require('./tour')
require('./twitter')
require('./legal-status-matching-criteria')
require('../documents');
require('../validator');
